<template>
    <div class="pay-cancel">
        <div class="cancel-head">
            <div class="location-btn" @click="startPage">키오스크로 돌아가기</div>
        </div>
        <div class="datePicker">
            <label>날짜 선택 : </label>
            <date-range-picker
                :ranges="ranges"
                :showDropdowns="showDropdowns"
                :opens="opens"
                :locale-data="localeData"
                v-model="dateRange"
                @update="dataUpdate"
            >
            </date-range-picker>

        </div>
        <div>
            <div id="grid"></div>
        </div>
    </div>
</template>

<script>

import * as config from '../../javascript/config';

import vue from 'vue';
import moment from 'vue-moment';
import Grid from 'tui-grid';
import DateRangePicker from 'vue2-daterange-picker';
import external from '@/assets/js/external.js';
import store from '../../javascript/store';

let vueComponent;

vue.use(moment);
export default {
    components: {DateRangePicker},
    data: function () {
        return {
            /* dateRangePicker 세팅 */
            toDay:'',
            yesterDay:'',
            yesterWeek:'',
            yesterMonth:'',
            dateRange: {
                startDate: '',
                endDate: '',
            },
            opens: 'right',
            showDropdowns: true,
            localeData: {
                format: 'yyyy-mm-dd',
                separator: ' ~ ',
                applyLabel: '검색',
                cancelLabel: '취소',
                weekLabel: 'W',
                customRangeLabel: 'Custom Range',
                daysOfWeek: ['일', '월', '화', '수', '목', '금', '토'],
                monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                firstDay: 0
            },
            ranges:{
                '오늘': [],
                '어제': [],
                '지난 7일': [],
                '지난 30일': []
            },
            dataSources: []
        }
    },
    methods: {
        dataUpdate(param){
            let startDt  = this.$moment(param.startDate).format('YYYY-MM-DD');
            let endDt = this.$moment(param.endDate).format('YYYY-MM-DD');
            this.dataSearch(startDt, endDt);
        },
        dataSearch(start, end){
            const type = config.REQ_PAYMENT_DAY_LIST;
            const request_data = {
                startDt: start, // 현재 내가 사용중인 좌석 use id
                endDt: end // 이동할 좌석의 seat id
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: request_data
            }).then(response => {
                this.dataSources = response.data.contents;
                this.grid.resetData(this.dataSources);
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        startPage(){
            this.$router.push('/start');
        },
        readData(){
          this.dateRange.startDate = this.$moment(new Date()).add(-20, 'days').format('YYYY-MM-DD');
          this.dateRange.endDate = this.$moment(new Date()).format('YYYY-MM-DD');
          this.toDay = this.$moment(new Date())._d;
          this.yesterDay = this.$moment(new Date()).add(-1, 'days')._d;
          this.yesterWeek = this.$moment(new Date()).add(-7, 'days')._d;
          this.yesterMonth = this.$moment(new Date()).add(-30, 'days')._d;
          this.ranges['오늘'] = [this.toDay, this.toDay];
          this.ranges['어제'] = [this.yesterDay, this.yesterDay];
          this.ranges['지난 7일'] = [this.yesterWeek, this.toDay];
          this.ranges['지난 30일'] = [this.yesterMonth, this.toDay];
          this.dataSearch(this.dateRange.startDate, this.dateRange.endDate);
          //this.grid.readData(1, '', false)
        }

    },
    beforeDestroy(){

    },
    mounted() {
        this.dateRange.startDate = this.$moment(new Date()).add(-20, 'days').format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date()).format('YYYY-MM-DD');
        this.toDay = this.$moment(new Date())._d;
        this.yesterDay = this.$moment(new Date()).add(-1, 'days')._d;
        this.yesterWeek = this.$moment(new Date()).add(-7, 'days')._d;
        this.yesterMonth = this.$moment(new Date()).add(-30, 'days')._d;
        this.ranges['오늘'] = [this.toDay, this.toDay];
        this.ranges['어제'] = [this.yesterDay, this.yesterDay];
        this.ranges['지난 7일'] = [this.yesterWeek, this.toDay];
        this.ranges['지난 30일'] = [this.yesterMonth, this.toDay];
        this.dataSearch(this.dateRange.startDate, this.dateRange.endDate);
        vueComponent = this;

        var grid = new Grid({
            el: document.getElementById('grid'),
            data: this.dataSources,
            scrollX: true,
            scrollY: true,
            bodyHeight: 1400,
            rowHeight: 60,
            rowHeaders: ['rowNum'],
            columns: [
                {
                    header: '이름',
                    name: 'name',
                    filter: 'select',
                    align: 'center',
                    sortable: true,
                    width:100
                },
                {
                    header: '휴대폰번호',
                    name: 'user_hp',
                    align: 'center',
                    sortable: true,
                    width:120
                },
                {
                    header: '결제수단',
                    name: 'payment_name',
                    filter: 'select',
                    align: 'center',
                    sortable: true,
                    width:100
                },
                {
                    header: '결제금액',
                    name: 'payment_amount',
                    align: 'right',
                    sortable: true,
                    width:100
                },
                {
                    header: '결제시간',
                    name: 'payment_datetime',
                    filter: {
                        type: 'date',
                        format: 'yyyy.MM.dd',
                        operator: 'AND'
                    },
                    align: 'center',
                    sortable: true,
                    width:140
                },
                {
                    header: '구매상품',
                    name: 'goods_name',
                    align: 'center',
                    sortable: true,
                    width:150
                },
                {
                    header: '결제취소',
                    name: 'pay_cancel',
                    align: 'center',
                    renderer: {
                        type: paymentButtonRenderer,
                        options: {
                            text: '취소',
                            type: 'btn-layer',
                            align: 'center'
                        }
                    },
                    width:100
                },
                {
                    header: '영수증 재출력',
                    name: 'receipt_reprint',
                    align: 'center',
                    renderer: {
                        type: receiptButtonRenderer,
                        options: {
                            text: '출력',
                            type: 'btn-layer',
                            align: 'center'
                        }
                    },
                    width:100
                },
                {
                    header: '승인번호',
                    name: 'approval_number',
                    align: 'center',
                    sortable: true,
                    width:120
                },
                {
                    header: '카드사명',
                    name: 'payment_kind_name',
                    align: 'center',
                    sortable: true,
                    width:120
                },
            ],
            columnOptions: {
                // frozenCount: 1,
                frozenBorderWidth: 1,
            }

        });
        this.grid = grid;
        Grid.setLanguage('ko');
        Grid.applyTheme('striped', {
            grid: {
                border: '#aaa',
                text: '#333'
            },
            cell: {
                disabled: {
                    text: '#999'
                }
            }
        });
    },
}

    class paymentButtonRenderer {
        constructor(props) {
            const { grid, rowKey } = props;
            const { text } = props.columnInfo.renderer.options;
            const { type } = props.columnInfo.renderer.options;
            let self = this;
            if(props.value > 1){
                const el = document.createElement('button');
                el.classList.add(type);
                el.addEventListener('click', function(){
                    if(confirm('결제 취소 요청을 하시겠습니까?')){
                        let data = {}
                        vueComponent.dataSources.forEach(e => {
                            if(e.payment_history_id == props.value){
                                data = e;
                                external.cancelPaymentByCard(data, props.value, e.goods_type_code, e.user_hp, self.suc_function);
                            };
                        });
                    }
                })
                el.innerHTML = text;
                this.el = el;
            }else{
                const el = document.createElement('span');
                el.innerHTML = '';
                this.el = el;
            }


            if(props.value !== null){
                this.render(props);
            }
        }

        getElement() {
        return this.el;
        }

        suc_function = function(msg, id, goods_type_code, user_hp){
            let msgString = "";
            if(msg.indexOf("정상취소거래") != -1) {
                msgString = "결제가 정상적으로 취소되었습니다.";

                const type = config.REQ_PAYMENT_CANCEL_UPDATE;
                const data = {
                    payment_history_id: id, // 현재 내가 사용중인 좌석 use id
                    user_hp : user_hp,
                    goods_type_code: goods_type_code
                };
                vueComponent.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                   vueComponent.readData()
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }else{
                msgString = "취소에 실패했습니다.<br>사유 : "+ msg;
            }
            const alert_param = {
                code: vueComponent.$store.getters['get_popup_code'].POPUP_ALERT,
                message: msgString,
            };

            vueComponent.$store.commit('set_popup_type', alert_param);
        }
        render(props) {
        //   this.el.src = String('/images/attachment.png');
        }
    }

















    class receiptButtonRenderer {
        constructor(props) {
            const { grid, rowKey } = props;
            const { text } = props.columnInfo.renderer.options;
            const { type } = props.columnInfo.renderer.options;
            let self = this;
            if(props.value > 1){
                const el = document.createElement('button');
                el.classList.add(type);
                el.addEventListener('click', function(){
                    if(confirm('영수증을 재출력 하시겠습니까?')){
                        vueComponent.dataSources.forEach(e => {
                            if(e.payment_history_id == props.value){
                                const type = config.REQ_RECEIPT_REPRINT_INFO;
                                const data = {
                                    payment_history_id: e.payment_history_id, // 현재 내가 사용중인 좌석 use id
                                };
                                vueComponent.$store.dispatch(type.action_name, {
                                    type: type,
                                    data: data
                                }).then(response => {
                                  var store_data = vueComponent.$store.getters['getStoreInfo'];
                                  vueComponent.$store.commit('set_receipt_setting_detail', "receipt_reprint");
                                  var dataset = {};
                                  dataset.userName = e.name; // 사용자 이름
                                  dataset.goodName = e.goods_name; // 상품명
                                  dataset.totalPay = e.payment_amount;   // 결제 금액
                                  dataset.payment_kind_code = response.data.contents[0].payment_kind_code; // 결제 종류
                                  dataset.pay_type = e.payment_name;   // 결제 종류
                                  dataset.appNumber = e.approval_number;   // 승인번호
                                  dataset.payment_kind_name = e.payment_kind_name; // 카드사명
                                  dataset.card_number = response.data.contents[0].card_number; // 카드번호
                                  dataset.card_div = e.card_div; // 할부개월
                                  dataset.receipt_setting = vueComponent.$store.getters['get_receipt_setting_detail'];    // 프린트 세팅
                                  external.printReceipt(store_data, dataset);
                                }).catch(function (error) {
                                    console.log('error=============>', error);
                                });

                            };
                        });
                    }
                })
                el.innerHTML = text;
                this.el = el;
            }else{
                const el = document.createElement('span');
                el.innerHTML = '';
                this.el = el;
            }


            if(props.value !== null){
                this.render(props);
            }
        }

        getElement() {
        return this.el;
        }

        render(props) {
        //   this.el.src = String('/images/attachment.png');
        }
    }
</script>
<style scoped>
</style>
<style>
    @import '../components/css/vue2-daterange-picker.css';
    @import '../components/css/tui-grid.css';

    .tui-grid-cell-content{font-size: 15px !important;}
    .btn-layer{width:80px; height:30px; line-height:30px; border:solid #bbb;color:#222; background-color:#FFFFFFFF;border-radius: 5px;}
    .location-btn{cursor:pointer;font-size: 40px;text-align: center;margin: 100px;border: solid;height: 100px;line-height: 100px;}
    .datePicker{text-align: left;margin: 50px 100px;}
</style>



// WEBPACK FOOTER //
// src/components/page/payment_cancel.vue